import PropTypes from 'prop-types';

import Input from '../Input';
import InputMask from '../InputMask';
import InputSelect from '../InputSelect';
import listCountries from '../../utils/Countries';

import { SwitchRow, Track, SwitchLabel } from './styles';

const propTypes = {
  isForeigner: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

/**
 * CPF, ou passaporte com o país emissor.
 *
 * O switch é só visual: ele não vai no formulário. Quem diz que a pessoa é
 * estrangeira é a ausência de CPF, e é assim que o resto do sistema lê — por
 * isso o componente envia um campo ou o outro, nunca os dois.
 *
 * Vive aqui, e não em cada página, porque cadastro e perfil precisam da mesma
 * regra e divergir entre os dois seria fácil demais.
 */
const DocumentFields = ({ isForeigner, onToggle }) => (
  <>
    <SwitchRow>
      <Track
        type="button"
        role="switch"
        aria-checked={isForeigner}
        aria-label="Sou estrangeiro"
        id="foreigner-switch"
        isOn={isForeigner}
        onClick={() => onToggle(!isForeigner)}
      />
      <SwitchLabel htmlFor="foreigner-switch" onClick={() => onToggle(!isForeigner)}>
        Sou estrangeiro
      </SwitchLabel>
    </SwitchRow>

    {isForeigner ? (
      <>
        <Input type="text" name="passportNumber" label="Passaporte" />
        <InputSelect
          name="passportCountry"
          label="País emissor"
          placeholder="Selecione o país"
          noOptionsMessage="Nenhum país encontrado"
          options={listCountries()}
        />
      </>
    ) : (
      <InputMask name="cpf" label="CPF" mask="999.999.999-99" />
    )}
  </>
);

DocumentFields.propTypes = propTypes;

export default DocumentFields;
